import { NavLink, Outlet, useParams } from "react-router-dom";
import Box from "@mui/system/Box";
import { styled } from "@mui/material/styles";
import { IconHome } from "@tabler/icons";

const LinkStyle = styled(NavLink)(({ theme }) => ({
  backgroundColor: theme.palette.primary[200],
  color: theme.palette.primary[500],
  fontWeight: 500,
  padding: "0.2rem 1rem",
  borderRadius: "1rem",
  border: "1px solid",
  borderColor: theme.palette.secondary[300],
}));

export default function ProjectLayout({ children }) {
  const { projectId } = useParams();

  const isActive = ({ isActive }) => {
    if (!isActive) return {};

    return {
      fontWeight: "bold",
      pointerEvents: "none",
    };
  };
  return (
    <>
      <Box
        sx={{ mt: -3, mb: 2, display: "flex", flexWrap: "wrap", displayPrint: "none", gap: 2, alignItems: "center" }}
      >
        <NavLink
          end
          style={({ isActive }) => ({ color: isActive ? "#9897c0" : "#4d4c7d" })}
          to={`/project/${projectId}/details`}
        >
          <IconHome />
        </NavLink>

        <LinkStyle end style={isActive} to={`/project/${projectId}/buyer`}>
          Buyer
        </LinkStyle>

        <LinkStyle end style={isActive} to={`/project/${projectId}/land/expense`}>
          Land Expense
        </LinkStyle>

        <LinkStyle end style={isActive} to={`/project/${projectId}/expense`}>
          Project Expense
        </LinkStyle>

        <LinkStyle end style={isActive} to={`/project/${projectId}/expense/vault`}>
          Expense Vault
        </LinkStyle>

        <LinkStyle end style={isActive} to={`/project/${projectId}/construction-charge`}>
          Const. srv. Charge
        </LinkStyle>
        <LinkStyle end style={isActive} to={`/project/${projectId}/report/income-expense`}>
          Report
        </LinkStyle>
      </Box>
      {children || <Outlet />}
    </>
  );
}
